import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { getProjectDetails, getProjectItems } from "./redux/projectSlice";
import ProjectViewDetails from "./components/projectViewDetails";
import ProjectViewCompanyList from "./components/projectViewCompanyList";
import ProjectViewItems from "./components/ProjectViewItems";
import { StepperContentHolder } from "../vendorRegistration/vendorRegistration";

export default function ProjectView() {
  const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    if (id) {
      dispatch(getProjectDetails(id));
      dispatch(getProjectItems(id));
    }
  }, [dispatch, id]);

  return (
    <StepperContentHolder>
      <ProjectViewDetails />
      <ProjectViewItems />
      <ProjectViewCompanyList />
    </StepperContentHolder>
  );
}
